<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.25 12C2.25003 6.61524 6.61524 2.25 12 2.25C17.3847 2.25002 21.75 6.61526 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM15.7439 9.50423C16.221 10.2185 16.4995 11.0765 16.4995 12C16.4995 13.0199 16.1599 13.9601 15.588 14.7148L18.2521 17.3789C19.496 15.9344 20.2501 14.0558 20.2501 12C20.2501 10.0398 19.5648 8.24056 18.423 6.82513L15.7439 9.50423ZM6.82461 18.4235C8.24006 19.5654 10.0398 20.2501 12 20.2501C13.9602 20.2501 15.7594 19.5648 17.1749 18.423L14.4963 15.7444C13.7819 16.2216 12.923 16.5 11.9995 16.5C11.0761 16.4999 10.2179 16.2215 9.50371 15.7444L6.82461 18.4235ZM12 9.00031C10.3432 9.00031 9.00035 10.3432 9.00031 12C9.00031 13.6568 10.3431 14.9997 12 14.9997C13.6568 14.9997 14.9997 13.6568 14.9997 12C14.9996 10.3432 13.6568 9.00034 12 9.00031ZM5.57647 6.82461C4.43461 8.24005 3.74985 10.0398 3.74984 12C3.74984 14.0559 4.50344 15.9349 5.74738 17.3794L8.41146 14.7153C7.83958 13.9607 7.50006 13.0203 7.49996 12.0005C7.49996 11.0769 7.77781 10.2176 8.25506 9.5032L5.57647 6.82461ZM9.28464 8.41146C10.0394 7.83952 10.98 7.50047 12 7.50047C13.02 7.50048 13.9606 7.8395 14.7153 8.41146L17.3789 5.7479C15.9344 4.50399 14.0558 3.74985 12 3.74984C9.94413 3.74984 8.0651 4.50347 6.62056 5.74738L9.28464 8.41146Z"
      :fill="fill"/>
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsBuoy'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>